module.exports = __webpack_public_path__ + "assets/-_13.1e5ad073.svg";